export const clearDispositionSections = (sections) => {
    for (let i = 0; i < sections.length; i++) {
        if (sections[i].dispositionSection) {
            sections[i].isSelected = false;
            return true;
        }
        if (clearDispositionSections(sections[i].subSections))
            return true;
    }
    return false;
};
//# sourceMappingURL=utils.js.map